const cloudImageBaseUrl = 'https://img.fablecdn.net/images/'

export default cloudImageBaseUrl
